import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages, ErrorId } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    optIn: string,
    step: {
        success: {
            redirect: string,
        }
    }
};


export const messagesJA: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    schoolName: '学校',
    infoShared1: ` `,
    informationTransferredToUS: ' ',
    infoShared2: ' ',
    optIn: `このボックスにチェックを入れ、「確認する」をクリックすることで、認証手続きにお客様の情報を提供することに同意したことになります。また、お客様の情報が Lenovo と共有されることを理解したということになります。　
    お客様の当核情報はアメリカ合衆国に送信され、<a target="_blank" class="sid-link" href="https://www.sheerid.com/privacy-policy/">SheerID のプライバシーポリシー</a> 、および、<a target="_blank" class="sid-link" href="https://www.lenovo.com/privacy/">Lenovo のプライバシー・ステートメント</a>.に従って適切に扱われます。 `,
    howDoesVerifyingWork: '認証サービスの仕組みに関して',
    poweredBy: '本認証サービスは SheerID 社が提供しています。SheerID 社に関する',
    sheeridFaqs: 'よくある質問はこちら',
    firstName: '名',
    lastName: '姓',
    birthDate: '生年月日',
    verificationPurposesOnly: ' 認証目的のためのみに使用されます。',
    emailAddress: 'E メールアドレス',
    emailExplanation: '認証の状況をお知らせする、認証用コード送信時に利用させていただきます。',
    verifyMyStudentStatus: '認証を続ける',
    countries: {
        HK: 'Hong Kong S.A.R. of China',
        TW: 'Taiwan Region',
    },
    step: {
        personalInfo: {
            title: '認証を始める',
            subtitle: '以下のフォームをご記入ください。学生優待のご利用条件を満たしているか確認させていただきます。​',
            howDoesVerifyingWorkDetails: `"SheerID 大学生優待を受けるためには、SheerID で在学／在職状況を認証する必要があります。

            SheerID とは、認証プロセスを通じて SheerID 大学生優待の対象となるお客様を確認するために Lenovo が提携しているサードパーティサービスです。お客様の個人情報は学生割引の認証手続きのみに使用します。第三者への貸与、売り渡し、提供、開示はいたしません。また、アップロードされた書類や画像を保管することもありません。
            詳しくはこちらの SheerID 社のよくある質問、や、 個人情報保護方針(英語）、をご覧ください。"`,
        },
        success: {
            title: 'お客様は SheerID での認証を完了しました。',
            subtitle: '下記のボタンをクリックし、引き続きお買い物をお楽しみください。お客様の SheerID 枠割はカートに直接適用されます。',
            redirectButtonText: 'レノボ・ショッピングへ戻る',
            redirect: 'レノボ・ショッピングへ戻る',
            emailNotification: '後ほどお買い物をされるお客様には、ご利用いただく際に必要な情報を、お客様のメールにお送りさせていただきました。verify@sheerid.com からのメールをご確認ください。',
            verificationOnly: 'SheerID は認証サポートのみを行っております。認証完了後、もしキャンペーンの条件やコードの利用等に関するご質問がある場合は、レノボ・ショッピングのご購入の相談窓口までお寄せください。',
        },
        docUpload: {
            title: 'お客様の学生証、または学校の授業スケジュールで認証を行う',
            subtitle: 'Lenovo とパートナーシップを組んでいる SheerID 社のスタッフにより、{estimatedWaitTime} による認証をおこないます。認証はどのように行われるのか？',
            howDoesVerifyingWorkDetails: `SheerID 大学生優待を受けるためには、SheerID で在学／在職状況を認証する必要があります。

            SheerID とは、認証プロセスを通じて優待の対象となるお客様を確認するために Lenovo が提携しているサードパーティサービスです。お客様の個人情報は学生割引の認証手続きのみに使用します。第三者への貸与、売り渡し、提供、開示はいたしません。また、アップロードされた書類や画像を保管することもありません。
            詳しくはこちらの SheerID 社のよくある質問、や、 個人情報保護方針(英語）、をご覧ください。`,
            uploadInstructions: '以下の項目が記載された、在籍する学校より発行された書類や写真をスキャンし、アップロードをお願いします。',
            acceptableUploadExamples: '有効な書類や写真の例：',
            fileInstructions: 'ファイルをここにドラッグ＆ドロップするか、参照をしアップロードしてください。',
            acceptedTypes: 'アップロード可能なファイルは.jpg .jpeg .png .pdf .gif もしくは .bmp 形式のみになります。',
            uploadInfo: {
                fullName: 'お客様のフルネーム',
                student: {
                    school: '学校名',
                    enrollmentDate: '今期（または過去3ヶ月以内）の在籍を証明する日付',
                }
            },
            acceptableUploads: {
                student: {
                    idCard: '有効期限が記載された学校の在籍カード、学生証',
                    classSchedule: '授業のスケジュール',
                    tuitionReceipt: '学費の支払領収書、学校が発行する公式な書類等',
                }
            },
        },
        sso: {
            title: '学校の認証情報を使って確認する',
            subtitle: '学校のポータルサイトにサインインしてください。新しいタブで表示されます。',
            login: 'お客様の学校にサインインする',
        },
        pending: {
            titleReview: '審査中',
            subtitleAlt: 'SheerID は只今、お客様の提出された書類を確認しています。',
            subtitle2: 'このままお待ちいただくか、後ほど結果をお知らせさせていただきます。',
            docDiffLang: 'お客様の提出された書類が英語以外の言語で書かれているため、認証に少々時間をいただく場合がございます。',
            turnaroundTime: 'お客様の提出された書類の確認には、通常{estReviewTime}程かかりますが、混雑時の場合には{maxReviewTime}程、要することもございますのでご了承ください。',
        },
        emailLoop: {
            title:'SheerID からのメールをご確認ください',
            subtitleWithEmail:'SheerID 認証手続きを完了するためのEメールを、お客様宛の{email}にお送りいたしました。',
            subtitleWithoutEmail:'SheerID 認証手続きを完了するためのEメールを、お客様宛にお送りいたしました。',
            subtitle2:'詳細については、SheerID（verify@sheerid.com）からのメールをご確認ください。',
            successResend:'メールの再送をいたしました。',
            resendButton:'再送信',
            errors:{
                resend:'メール送信エラー',
            },
            skipEmail:'このメールの受信がうまくできませんでしたか？クリック',
            skipEmailCTA:'こちらを',
            skipEmail2:'進んでください。'
        }
    },
};
